import React from 'react';
import {Link,} from 'react-router-dom'
import {SidebarData} from './SidebarData';
import './Navbar.css';
import {IconContext} from 'react-icons';
import logo from '../../assets/loggo.png'
import {useTranslation} from "react-i18next";

import LanguageChangeButtonForDesktop from "../LanguageChangeButtonForDesktop";

function Navbar() {
    const {t} = useTranslation();
    return (
        <>
            <LanguageChangeButtonForDesktop/>
            <Link to='/'>
                <img src={logo} alt="logo" className='logo'/>
            </Link>
            <ul className="containers">
                {SidebarData.map((item) => {
                    return <li key={item.id} className={item.aName}>
                        <Link to={item.path} onClick={() => {
                            document.getElementById('footer_id').style = 'display:none';
                        }}>
                            <span>{t(`${item.title}`)}</span>
                        </Link>
                    </li>
                })}
            </ul>
            <IconContext.Provider value={{color: '#333'}}>
                <ul className="mobile-navigation-bar-list">
                    {SidebarData.map((item) => {
                        return <li key={item.id}>
                            <Link to={item.path}  onClick={() => {
                                document.getElementById('footer_id').style = 'display:none';
                            }}>
                                <span className="span-nav-list-icon">{item.icon}</span>
                                <span className="span-nav-list"> {t(`${item.title}`)}</span>
                            </Link>
                        </li>
                    })
                    }
                </ul>
            </IconContext.Provider>
        </>
    );
}

export default Navbar;